.stack {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
}

.foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-4);
  flex-wrap: wrap;
  width: 100%;
}

.footHint {
  font-size: var(--font-size-s);
  color: var(--color-grey);
}

.footActions {
  display: flex;
  gap: var(--spacing-2);
  margin-left: auto;
}
